import cardsSprite from './drawCard';
import CardsImage from '../../../assits/cards.jpg';

export default function getCard(id, classname) {
	cardsSprite(CardsImage, 4, 8, 1, function (drawCard) {
		let myHand = document.getElementById(`${id}`);
		if (!myHand) return;

		let ecards = myHand.getElementsByClassName(`${classname}`);
		let type = {
			heart: 0,
			nut: 1,
			leave: 2,
			bell: 3,
		};
		let value = {
			jack: 0,
			queen: 1,
			king: 2,
			septar: 3,
			optar: 4,
			nine: 5,
			ten: 6,
			ace: 7,
		};

		for (let k = 0; k < ecards.length; k++) {
			let c = ecards[k];

			if (
				c.children &&
				!c.classList.contains('card_bottom') &&
				!c.classList.contains('card_left')
			) {
				c.innerHTML = '';
			}

			let attr = c.getAttribute('data-card');
			if (attr) {
				let p = attr.split(' ');
				c.title = p[0] + ' of ' + p[1];
				c.appendChild(
					drawCard(type[p[1]], value[p[0]], c.getAttribute('data-disabled'))
				);
			}
		}
	});
}
